import { SearchBarResult } from '../components/Header/SearchBar/types';
import request from '../utils/request';

export const fetchSearchResults = async (
    searchString: string
): Promise<SearchBarResult> => {
    const results = await request.get(`/search?query=${searchString}`);
    return results.data;
};

export const fetchSearchUsersResults = async (
    searchString: string
): Promise<SearchBarResult> => {
    const results = await request.get(`/search/users?query=${searchString}`);
    return results.data;
};
